import Qs from "qs"
import { encryption } from "./index"
import { data_dictionary_map } from "root/static/dataDictionary"
import instance from "../interceptor"
import api from "../api/index"
import { addSubPageMapping, updateSubPageMapping } from "@/utils/updateData/publicDataUtils/subPageUpdateData"
import { getAttrById } from "utils"

/**
 * @param typeId 给组件绑定数据前需要先收藏该样式，1、组件直接绑定，需要传typeId=31CB73E03E24BBFF 原来的 10016  ；2、组件收藏成样式，需要传typeId=6D39D43861AF4301  原来的15
 * @param typeName
 * @param appId 如果传了appId，则说明该组件是系统样式，需要替换其appId
 * @param flag 如果是收藏好的样式组件，需要传flag=true，表示不需要修改appId,否则传flag=false
 * @param replacePageId 用于替换的pageId, 
 */
export async function saveModule(ids, typeId, typeName, chart, appId, flag, isClone, replacePageId) {
  const _ids = ids ? ids : { ...this.ids }
  let type = "rect"
  //1--兼容在布局组件或在轮播组件内的组件单独绑定数据的逻辑
  if (
    _ids.elementInLayoutId !== null &&
    _ids.uid !== null &&
    !isNaN(_ids.elementInLayoutId) &&
    _ids.uid !== undefined
  ) {
    type = "elementInLayout"
  }
  if (
    _ids.swiperContent_id !== null &&
    _ids.elementInSwiperId !== null &&
    !isNaN(_ids.elementInSwiperId) &&
    !isNaN(_ids.swiperContent_id)
  ) {
    type = "elementInSwiper"
  }
  if (
    _ids.elementInAutoLayoutId !== null &&
    _ids.elementInAutoLayoutId !== null &&
    !isNaN(_ids.elementInAutoLayoutId) &&
    !isNaN(_ids.elementInAutoLayoutId)
  ) {
    type = "elementInAutoLayout"
  }
  const { pageId, wfwfid } = this.$store.state.states.getDataPageIds
  const params = {
    a: appId ? appId : chart ? "ACF9813F7466EEC8" : "7C5C8F204A2F4171", // 先判断当前是否传递了appId
    // w: wfwfid,
    w: -10,
    p: replacePageId || pageId,
    c: {},
    t2: typeId,
    t: typeName,
    clone: isClone
  }
  //如果是模板中的图表组件 就不用请求appid
  const appIdRes = await getParam(params, false)
  if (appIdRes.data.code == 1) {
    // 添加组件后，需要给组件建立子页面映射关系
    // const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], _ids, type)
    const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], _ids)
    console.log("rectAttr",rectAttr)
    console.log("ids",ids)
    if (
      (rectAttr.shape === "emptyLayoutComponent" ||
      rectAttr.shape === "swiperComponent" ||
      rectAttr.shape === "cxNavMenu") && this.request_prefix !== "bigScreen"
    ) {
      await addSubPageMapping.call(this, appIdRes.data.data.appId)
    }
    if (appIdRes?.data?.data?.moduleId) {
      // appId同时放到rect里方便前端使用
      if (!flag) {
        // 不需要在这儿修改appId
        if (type === "rect") {
          this.$store.dispatch(this.request_prefix + "/updateAppId", {
            ..._ids,
            appId: appIdRes.data.data.appId
          })
          this.$store.dispatch(this.request_prefix + "/updateRectModuleIdTypeId", {
            ..._ids,
            moduleId: appIdRes.data.data.moduleId,
            typeId: params.t2
          })
        } else {
          this.$changeOptionsEV(appIdRes.data.data.appId, "appId", false, null, {
            ..._ids,
            isCheckAllCol: true
          })
          this.$changeOptionsEV(appIdRes.data.data.moduleId, "moduleId", false, null, {
            ..._ids,
            isCheckAllCol: true
          })
        }
      }

      return Promise.resolve({
        appId: appIdRes.data.data.appId,
        moduleId: appIdRes.data.data.moduleId
      })
    } else {
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "error",
        message: "没有cookies 请登录后从列表页进入!"
      })
      return Promise.reject("没有cookies")
    }
  } else {
    this.$message({
      customClass: "bigScreen_msg_backGroud",
      duration: 3000,
      type: "error",
      message: "没有cookies 请登录后从列表页进入!"
    })
    return Promise.reject("没有cookies")
  }
}
/*
 *
 * @param typeId 给组件绑定数据前需要先收藏该样式，1、组件直接绑定，需要传typeId=10016；2、画布收藏成模板，需要传typeId=100
 * @param typeName
 * @param appId
 * @param isClone 是否是克隆组件
 * @param isSearchComponent 是否是搜索组件
 * @param isNavComponent 是否是导航组件
 */
export async function styleToSaveModule(typeId, typeName, appId, isClone, isSearchComponent, isNavComponent) {
  const { pageId, websiteId, wfwfid } = this.$store.state.states.getDataPageIds
  const params = {
    a: appId ? appId : "7C5C8F204A2F4171", // 先判断当前是否传递了appId
    w: -10,
    p: pageId,
    c: {},
    t2: typeId,
    t: typeName,
    clone: isClone
  }
  const appIdRes = await getParam(params, isClone)
  if (appIdRes.data.code == 1) {
    // 添加组件后，需要给组件建立子页面映射关系
    if (this.request_prefix !== "bigScreen") {
      await addSubPageMapping.call(this, appIdRes.data.data.appId, isSearchComponent, isNavComponent)
    }
    if (appIdRes?.data?.data?.moduleId) {
      // appId同时放到rect里方便前端使用
      return Promise.resolve({
        appId: appIdRes.data.data.appId,
        moduleId: appIdRes.data.data.moduleId
      })
    } else {
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "error",
        message: "没有cookies 请登录后从列表页进入!"
      })
      return Promise.reject("没有cookies")
    }
  } else {
    this.$message({
      customClass: "bigScreen_msg_backGroud",
      duration: 3000,
      type: "error",
      message: "没有cookies 请登录后从列表页进入!"
    })
    return Promise.reject("没有cookies")
  }
}

const getParam = async (params, isClone) => {
  return api.createComponentApp({
    param: params
  })
}

/*
 *
 * @param typeId
 * @param typeName
 * @param appId
 * @param isClone 是否是克隆组件
 * @param isSearchComponent 是否是搜索组件
 * @param isNavComponent 是否是导航组件
 */
export async function repairApp(typeId, typeName, appId, isClone, isSearchComponent, isNavComponent) {
  const { pageId, websiteId, wfwfid } = this.$store.state.states.getDataPageIds
  const params = {
    a: appId,
    w: websiteId,
    p: pageId,
    c: {},
    t2: typeId,
    t: typeName
  }
  const appIdRes = await getRepairParam(params, isClone)
  if (appIdRes.data.code == 1) {
    // 非大屏才处理子页面
    if (this.request_prefix !== "bigScreen") {
      // 需要更新组件的子页面映射关系
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(item => item.appId === appId)
      if (typeof index === "undefined" || index === -1) {
        // 没有子页面关系，建立子页面关系
        await addSubPageMapping.call(this, appIdRes.data.data.appId, isSearchComponent, isNavComponent)
      } else {
        // 有子页面关系，替换appId
        const subPageSettingIndex = index
        let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        temp[subPageSettingIndex].appId = appIdRes.data.data.appId
        updateSubPageMapping.call(this, temp)
      }
    }
    if (appIdRes?.data?.data?.moduleId) {
      // appId同时放到rect里方便前端使用
      return Promise.resolve({
        appId: appIdRes.data.data.appId,
        moduleId: appIdRes.data.data.moduleId
      })
    }
  } else {
    this.$message({
      customClass: "bigScreen_msg_backGroud",
      duration: 3000,
      type: "error",
      message: "没有cookies 请登录后从列表页进入!"
    })
    return Promise.reject("没有cookies")
  }
}

const getRepairParam = async (params, isClone) => {
  return api.repairDirtyDataApp({
    isClone: isClone,
    param: params
  })
}

const handleStageParam = (self, _ids, encAppId) => {
  let content = JSON.parse(
    JSON.stringify(
      self.$store.state[self.request_prefix].page.children.find((val, index, arr) => {
        if (val.container_id === _ids.container_id) {
          return val
        }
      })
    )
  )
  content.active = false
  content = encryption(content, data_dictionary_map)
  const param = {
    c: content,
    a: encAppId
  }
  return param
}
